import { getFirestore, doc, setDoc } from 'firebase/firestore';

// ─── Stripe Payment Links ─────────────────────────────────────────────────────
// Premium access -- monthly recurring subscription
export const PREMIUM_PAYMENT_LINK = 'https://buy.stripe.com/00w28k83BdB1burbjE5os0b';

// Legacy alias kept for any remaining call sites
const PAYMENT_LINK = PREMIUM_PAYMENT_LINK;

/**
 * Redirect to the Stripe Payment Link.
 * Passes client_reference_id (user UID) so the webhook can identify who paid,
 * and prefills their email for convenience.
 */
export const redirectToCheckout = async (user) => {
  try {
    const url = new URL(PAYMENT_LINK);
    if (user?.uid) url.searchParams.set('client_reference_id', user.uid);
    if (user?.email) url.searchParams.set('prefilled_email', user.email);
    window.location.href = url.toString();
    return { success: true };
  } catch (error) {
    console.error('Error redirecting to checkout:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Update user's premium status in Firestore
 * Call this from your webhook handler or success page
 */
export const upgradeToPremium = async (userId) => {
  try {
    const db = getFirestore();
    await setDoc(
      doc(db, 'users', userId),
      {
        premium: true,
        premiumSource: 'stripe',
        premiumUpdatedAt: new Date().toISOString(),
        premiumUpgradedAt: new Date().toISOString(),
      },
      { merge: true }
    );
    console.log('✅ User upgraded to premium:', userId);
    return { success: true };
  } catch (error) {
    console.error('❌ Error upgrading to premium:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Check if user has premium access
 */
export const hasPremiumAccess = (_user) => {
  // All stories are open to everyone; login is only needed to save stats.
  const { PAYWALL_ENABLED } = require('../config/featureFlags');
  if (!PAYWALL_ENABLED) return true;
  return Boolean(_user?.premium);
};

/**
 * Simple client-side payment simulator (DEVELOPMENT ONLY)
 * This bypasses Stripe and directly upgrades the user
 * REMOVE THIS IN PRODUCTION!
 */
export const simulatePayment = async (user) => {
  console.warn('⚠️ Using simulated payment - FOR DEVELOPMENT ONLY');
  
  // Simulate a delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Upgrade user to premium
  const result = await upgradeToPremium(user.uid);
  
  return result;
};
